/**
 * @return {string | undefined}
 */
module.exports = function getCompanyEmailPattern() {
    const emailPatternMeta = document.querySelector('meta[name="itbl_email_pattern"]');

    if (emailPatternMeta) {
        const emailPatternBase64 = emailPatternMeta.getAttribute("content");
        return atob(emailPatternBase64, true);
    }
}